import { useNavigate } from 'react-router-dom';
import Button from 'components/new-ui/base/button/Button';
import { useMultiStepFormContext } from 'components/new-ui/composed/multistep-form/MultiStepFormProvider';
import PageHeader from 'components/new-ui/base/page-header/PageHeader';
import ShipmentIcon from 'components/icons/ShipmentIcon';
import { useFormikContext } from 'formik';
import useGlobalOverlay from 'hooks/useGlobalOverlay';
import { submitShipmentForm } from '../../utils';
import { NewShipmentFormFields } from '../../types';
import { notification } from 'antd';
import { ValidationError } from 'yup';

const Header: React.FC = () => {
    const navigate = useNavigate();
    const { isReadyToSubmit, isSubmitting } = useMultiStepFormContext();
    const { values } = useFormikContext<NewShipmentFormFields>();
    const { showGlobalOverlay, hideGlobalOverlay } = useGlobalOverlay();

    const handleCancel = () => {
        navigate('/shipments');
    };

    const handleFormSubmit = async () => {
        try {
            showGlobalOverlay({
                type: 'LoadingOverlay',
                payload: {
                    message: 'Creating shipment...',
                },
            });

            await submitShipmentForm(values);

            notification.success({
                message: 'Shipment submitted',
            });

            navigate('/shipments', {
                replace: true,
            });
        } catch (err: any) {
            if (err instanceof ValidationError) {
                notification.error({
                    message: 'Validation failed',
                    description: err.message,
                });
            } else {
                notification.error({
                    message: 'Could not create shipment',
                    description: err.message || 'An unexpected error occurred',
                });
            }
        } finally {
            hideGlobalOverlay();
        }
    };

    return (
        <PageHeader
            title="Create Shipment"
            icon={<ShipmentIcon />}
            sidebar={
                <div>
                    <Button style={{ marginRight: 16 }} onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        disabled={!isReadyToSubmit()}
                        loading={isSubmitting}
                        onClick={handleFormSubmit}
                    >
                        Create Shipment
                    </Button>
                </div>
            }
        />
    );
};

export default Header;
